// src/ResetPassword.js
import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      await sendPasswordResetEmail(auth, email);
      // ✅ Secure wording so attackers can't guess accounts
      setMessage("If your email exists, a reset link has been sent.");
    } catch (err) {
      console.error("❌ Reset error:", err.message);
      // Keep vague for security reasons
      setMessage("If your email exists, a reset link has been sent.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 bg-white">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">🔑 Reset Password</h1>

      <form onSubmit={handleReset} className="w-full max-w-sm space-y-4">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-2 border rounded-md shadow"
          required
        />
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
        >
          Send Reset Link
        </button>
      </form>

      {message && <p className="text-green-600 mt-4">{message}</p>}
      {error && <p className="text-red-500 mt-4">{error}</p>}

      <p className="mt-6 text-sm text-gray-600">
        Remembered your password?{" "}
        <a href="/members" className="text-blue-600 underline hover:text-blue-800">
          Back to Login
        </a>
      </p>
    </div>
  );
}
